import { render, staticRenderFns } from "./DeveloperApprovalTable.vue?vue&type=template&id=68287e50&"
import script from "./DeveloperApprovalTable.vue?vue&type=script&lang=ts&"
export * from "./DeveloperApprovalTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports